import React from "react";



function Profile({ profile }) {
  if (profile !== "" && profile.status !== 404 && profile.totalRecords !== 0) {
    return (
      <div className="mt-3 mt-sm-5">
        <h3 className="">Profile</h3>
        <h6>{profile.name}</h6>
        <PinkItems profile={profile} />
        <p>{profile.address1}</p>
        <p>{profile.address2}</p>
        <p>{profile.country}</p>
        <p>{profile.email}</p>
        <p>{profile.website}</p>
        <p>+{profile.phone}</p>
        <p>{profile.description}</p>
        <p>{profile.linkedIn}</p>
      </div>
    );
  } else if(profile.error === "Not Found") {
    return (
    <div>
    {/* <NotAvailable/> */}
    </div>
    )
  }else{
    return ""
  }
}

function BusinessDesc({ profile }) {
  if (
    profile !== "" &&
    profile.status !== 404 &&
    profile.totalRecords !== 0 &&
    profile.businessDesc !== undefined
  ) {
    return (
      <div className="mt-3 mt-sm-5">
        <h3 className="font-bold">Business Description</h3>
        <p>{profile.businessDesc}</p>
      </div>
    );
  } else {
    return "";
  }
}

function Officers({ profile }) {
  if (
    profile !== "" &&
    profile.status !== 404 &&
    profile.totalRecords !== 0 &&
    profile.officers.length > 1
  ) {
    return (
      <div className="mt-3 mt-sm-5">
        <h3 className="font-bold text-xl text-sm-2xl">
          Company Officers and Contacts
        </h3>
        {profile.officers.map((officer, index) => {
          return (
            <div key={index} className="d-flex">
              <p className="pr-5">{officer.name}</p>
              <p>{officer.title}</p>
            </div>
          );
        })}
      </div>
    );
  } else {
    return "";
  }
}

function PinkItems({ profile }) {
  if (profile !== "" && profile.status !== 404 && profile.totalRecords !== 0) {
    return <p>{profile.securities[0].tierDisplayName}</p>;
  } else {
    return "";
  }
}

function ProfileContainer({ profile }) {
  return (
    <div className="position-relative px-2 px-sm-5 text-2sm">
      <div className="d-block d-sm-flex">
        <div>
          <Profile profile={profile} />
        </div>
        <div>
          <BusinessDesc profile={profile} />
        </div>
      </div>
      <Officers profile={profile} />
    </div>
  );
}

export default ProfileContainer;
